import { appService } from '../_services';
import { processApiError } from '../_helpers';

export const app = {
  namespaced: true,
  state: {
    error: '',
    objects: {},
    isMobile: false,
    userRights: null
  },
  actions: {
    runApp({ commit }) {
      appService.runApp().then(
        (userRights) => {
          commit('setUserRights', userRights);
        },
        error => {
          processApiError(error);
        }
      );

      commit('setSelectedPage', { obj: 'compass', page: 1 });
    },
  },
  mutations: {
    setUserRights(state, data) {
      state.userRights = {};
      data.map(e=>{
        state.userRights[e.key_name] = !!e.access;
      });
    },
    setSelectedPage(state, data) {
      if (!state.objects[data.obj]) {
        state.objects[data.obj] = {};
      }
      state.objects[data.obj].selectedPage = data.page;
    },
  },
};
